export default "__VITE_ASSET__DTZ6sG6h__"